<template>
<transition name="fade">
  <div
    class="app-audio"
    v-show="$store.state.currentGame.questionsIndex >= 0
      && $store.state.currentGame.questionsIndex !== null
      && !$store.state.currentGame.gameEnded"
  >
    <div class="audio-control" @click="toggleAudio">
      <svg x="0px" y="0px" viewBox="0 0 36 31">
        <g id="sound-on" v-if="!muted">
          <path
            fill="#b9ad9e"
            d="M0,9.2v12.6c0,0.5,0.1,0.9,0.3,0.9h1.8V8.3H0.3C0.1,8.3,0,8.7,0,9.2z"
          />
          <path
            fill="#b9ad9e"
            d="M15.1,0.1L2.1,8.5v14l13.1,8.4c0.6,0.4,1.4,0,1.4-0.8V0.9C16.5,0.2,15.8-0.2,15.1,0.1z"
          />
          <path
            fill="#b9ad9e"
            d="M21.1,8.6c-0.3-0.4-0.9-0.5-1.2-0.1L18.8,10c-0.2,0.2-0.2,0.6-0.1,0.9c0.5,1.1,0.9,2.3,
            0.9,3.6s-0.3,2.5-0.9,3.6c-0.1,0.3-0.1,0.6,0.1,0.9l1.2,1.5c0.3,0.4,0.9,0.3,1.2-0.1c1-1.7,
            1.6-3.7,1.6-5.8S22.1,10.3,21.1,8.6z"
          />
          <path
            fill="#b9ad9e"
            d="M25.3,4.4C25,4,24.4,4,24.1,4.4l-1.2,1.3c-0.2,0.3-0.2,0.6,0,0.9c1.7,2.1,2.7,4.8,2.7,
            7.8c0,2.9-1,5.6-2.7,7.8c-0.2,0.3-0.2,0.7,0,0.9l1.2,1.3c0.3,0.4,0.9,0.4,1.2,0c2.3-2.7,
            3.7-6.3,3.7-10.1S27.6,7.2,25.3,4.4z"
          />
          <path
            fill="#b9ad9e"
            d="M29.4,0.3c-0.3-0.3-0.9-0.3-1.1,0L27,1.6c-0.2,0.3-0.2,0.7,0,1c2.9,3.4,4.8,7.9,4.8,
            12.8S30,24.9,27,28.3c-0.2,0.3-0.2,0.7,0,1l1.2,1.4c0.3,0.3,0.9,0.3,1.1,0c3.6-4,
            5.8-9.4,5.8-15.2S32.9,4.3,29.4,0.3z"
          />
        </g>
        <g id="sound-off" v-else>
          <path
            fill="#b9ad9e"
            d="M27.1,14.5l4.3-4c0.6-0.6,0.6-1.4,0-2c-0.6-0.6-1.5-0.6-2.1,0l-4.3,
            4l-4.3-4c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.4,0,2l4.3,4l-4.3,4c-0.4,
            0.4-0.5,0.9-0.4,1.4c0.1,0.5,0.5,0.9,1.1,1c0.5,0.1,1.1,0,1.5-0.4l4.3-4l4.3,
            4c0.6,0.6,1.5,0.6,2.1,0c0.6-0.6,0.6-1.5,0-2L27.1,14.5z"
          />
          <path
            fill="#b9ad9e"
            d="M0,9.2v12.6c0,0.5,0.1,0.9,0.3,0.9h1.8V8.3H0.3C0.1,8.3,0,8.7,0,9.2z"
          />
          <path
            fill="#b9ad9e"
            d="M15.1,0.1L2.1,8.5v14l13.1,8.4c0.6,0.4,1.4,0,1.4-0.8V0.9C16.5,0.2,15.8-0.2,15.1,0.1z"
          />
        </g>
      </svg>
    </div>
  </div>
</transition>
</template>

<script>
import audio from '@/scripts/audio';

export default {
  name: 'AppAudio',

  data() {
    return {
      muted: false,
    };
  },

  methods: {
    toggleAudio() {
      if (this.muted) {
        audio.unmute();
      } else {
        audio.mute();
      }
      this.muted = !this.muted;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-audio {
  position: absolute;
  bottom: calc(var(--unit-vw) * 0.5);
  left: calc(var(--unit-vw) * 0.5);
  transform: translateX(-50%) translateY(50%);
  cursor: pointer;
  pointer-events: auto;

  svg {
    width: 16px;
    height: auto;

    opacity: 0.5;

    @include mq(d) {
      width: 18px;
    }
  }
}
</style>
